import { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { useTranslation } from "react-i18next";
import { fetchAccessData } from "../../store/Access-Right-Slice";
import UpgradeDetails from "../../Layout/upgrade-details";
import FloorPlan from "./3d-floor-plan";
import GenerateQRCode from "./generate-QR-code";
import RoomStaging from "./room-staging";
import StyleTransfer from "./style-transfer";
import GenerationItem from "./generation-item";
import RoomRemodeling from "./room-remodeling";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const AdvancedGeneration: React.FunctionComponent<{
    imageValue: any, onEnhancedImage: any, processingIds: (string | number)[],
    isApplyingMap: Record<string, boolean>, currentImageIndex?: any, listing: any,onChangeMessagehandler: any
}> = (props) => {

    const [openPopUp, setOpenPopUp] = useState<boolean>(false);
    const [stateValue, setIsStateValue] = useState<string>();
    let location = useLocation().pathname.split('/');
    const pathname = location[1];
    const dispatch = useDispatch<AppDispatch>();
    const accessValue = useSelector((state: RootState) => state.AccessRight.accessValue) as Record<string, boolean>;
    const [showUpgrade, setShowUpgrade] = useState(false);
    const currentImage = props.listing.images[props.currentImageIndex];
    const { t } = useTranslation();
    const disableAll = (currentImage?.doneEnhancments || []).includes("Image Super Resolution");

    useEffect(() => {
        dispatch(fetchAccessData());
    }, [dispatch]);

    const EnhancedImageHandler = (value: any) => {
        setOpenPopUp(false);
        props.onEnhancedImage(props.imageValue, stateValue, value);
    }

    const listGeneration = [
        {
            id: 1,
            apiName: "Room Staging",
            name: `${t("enhancementList.Room Staging")}`,
            component: <RoomStaging image={props.imageValue} onEnhancedImage={EnhancedImageHandler} onChangeMessagehandler={props.onChangeMessagehandler} />,
            popUp: true,
            allowReapply: true,
            svg: <svg width="18" height="18" className="marg-right-10" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_504_633)">
                    <path d="M17.4727 0H9H0.527344C0.236109 0 0 0.235969 0 0.527062V17.473C0 17.764 0.236109 18 0.527344 18H17.4727C17.7639 18 18 17.764 18 17.4729V0.527062C18 0.235969 17.7639 0 17.4727 0ZM16.9453 1.05409V10.129H15.9371C15.5238 9.84902 14.145 8.8714 12.7737 7.40985C11.3854 5.9303 9.74728 3.66247 9.54756 1.05412L16.9453 1.05409ZM14.1429 12.7119H3.85713C3.53225 11.8502 3.18389 11.2004 2.94416 10.8009C3.57057 10.3547 4.77777 9.42891 5.99569 8.1309C7.01251 7.04718 7.82445 5.9278 8.40888 4.80393C8.64221 4.35519 8.83934 3.90533 9.00004 3.45551C9.16073 3.9053 9.35786 4.35519 9.59119 4.80393C10.1756 5.9278 10.9875 7.04718 12.0044 8.1309C13.2223 9.42894 14.4295 10.3548 15.0559 10.8009C14.8161 11.2004 14.4677 11.8502 14.1429 12.7119ZM13.7951 13.766C13.5363 14.676 13.3362 15.7451 13.2898 16.9459H4.71013C4.66379 15.7451 4.46372 14.676 4.20483 13.766H13.7951ZM8.45241 1.05409C8.25318 3.65474 6.62379 5.91641 5.24292 7.39213C3.87021 8.85909 2.47809 9.84716 2.06265 10.129H1.05469V1.05409H8.45241ZM1.05469 16.9459V11.1831H1.93992C2.3528 11.8379 3.52775 13.9496 3.65467 16.9459H1.05469ZM14.3455 16.9459C14.4224 15.1508 14.8779 13.6888 15.2654 12.7474C15.574 11.998 15.8855 11.4604 16.0603 11.1831H16.9453V16.9459H14.3455Z" fill="black" />
                </g>
                <defs>
                    <clipPath id="clip0_504_633">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        },
        {
            id: 2,
            apiName: "Room Remodeling",
            name: `${t("enhancementList.Room Remodeling")}`,
            component: <RoomRemodeling image={props.imageValue} onEnhancedImage={EnhancedImageHandler} />,
            popUp: true,
            allowReapply: true,
            svg: <svg width="18" height="18" className="marg-right-10" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_715_1020)">
                    <path d="M7.82262 10.3447H11.2521C11.6434 10.3447 11.9616 10.0265 11.9616 9.63524V7.64539C11.9616 7.2541 11.6434 6.93594 11.2521 6.93594H7.82262C7.43133 6.93594 7.11316 7.2541 7.11316 7.64539V9.63524C7.11281 10.0265 7.43133 10.3447 7.82262 10.3447ZM9.76746 9.92281H7.84336L8.79926 8.92438L9.76746 9.92281ZM11.2518 9.92281H10.3553L9.65285 9.19859L10.6787 8.12703L11.5393 9.01473V9.63524C11.5397 9.79379 11.4103 9.92281 11.2518 9.92281ZM7.82262 7.35746H11.2521C11.4107 7.35746 11.5397 7.48649 11.5397 7.64504V8.40828L10.8295 7.67598C10.7898 7.63484 10.7353 7.61199 10.678 7.61199C10.6777 7.61199 10.6777 7.61199 10.6773 7.61199C10.62 7.61234 10.5652 7.63555 10.5258 7.67703L9.3593 8.89555L8.95008 8.47367C8.91035 8.43254 8.85586 8.40969 8.79855 8.40969C8.7982 8.40969 8.7982 8.40969 8.79785 8.40969C8.74055 8.41004 8.6857 8.43324 8.64633 8.47473L7.53504 9.63524V7.64539C7.53469 7.48649 7.66371 7.35746 7.82262 7.35746ZM12.3655 14.1971V13.3548C12.3655 12.8911 11.9883 12.5138 11.5246 12.5138H9.0798C8.82914 12.5138 8.60379 12.6242 8.4498 12.7986C8.29547 12.6242 8.07047 12.5138 7.8198 12.5138H5.37504C4.91133 12.5138 4.5341 12.8911 4.5341 13.3548V14.1985C4.20715 14.2432 3.95402 14.5234 3.95402 14.8626V16.4316C3.95402 16.548 4.04859 16.6426 4.16496 16.6426H5.32512C5.44148 16.6426 5.53605 16.548 5.53605 16.4316V16.2685H11.372V16.4316C11.372 16.548 11.4666 16.6426 11.5829 16.6426H12.7431C12.8595 16.6426 12.954 16.548 12.954 16.4316V14.8626C12.9537 14.5205 12.6963 14.2382 12.3655 14.1971ZM9.0798 12.9357H11.5246C11.7555 12.9357 11.9436 13.1238 11.9436 13.3548V14.1996C11.7123 14.234 11.5189 14.3863 11.4279 14.594C11.2704 14.4727 11.0732 14.4003 10.8594 14.4003H8.66039V13.3548C8.66039 13.1238 8.84848 12.9357 9.0798 12.9357ZM5.37469 12.9357H7.81945C8.05043 12.9357 8.23852 13.1238 8.23852 13.3548V14.4003H6.04758C5.83383 14.4003 5.6366 14.4727 5.4791 14.594C5.38699 14.3841 5.19047 14.2305 4.95527 14.1985V13.3551C4.95563 13.1238 5.14371 12.9357 5.37469 12.9357ZM5.11383 16.2204H4.37555V14.8623C4.37555 14.7248 4.48734 14.6134 4.62445 14.6134H4.86492C5.00238 14.6134 5.11383 14.7252 5.11383 14.8623V16.2204ZM5.5357 15.8463V15.3341C5.5357 15.0518 5.76527 14.8218 6.04793 14.8218H10.8594C11.1417 14.8218 11.3716 15.0514 11.3716 15.3341V15.8463H5.5357ZM12.5318 16.2204H11.7935V14.8623C11.7935 14.7248 11.9053 14.6134 12.0424 14.6134H12.2829C12.4204 14.6134 12.5318 14.7252 12.5318 14.8623V16.2204ZM14.9098 12.2034C14.9695 12.2034 15.0265 12.1781 15.0666 12.1338C15.1066 12.0895 15.126 12.0301 15.1196 11.9707L14.9597 10.4312C14.9305 10.1499 14.6953 9.93828 14.4127 9.93828H13.873C13.5904 9.93828 13.3552 10.1503 13.326 10.4312L13.166 11.9707C13.1597 12.0301 13.179 12.0895 13.2191 12.1338C13.2592 12.1781 13.3161 12.2034 13.3759 12.2034H13.9317V15.4786H13.7573C13.4427 15.4786 13.1864 15.7345 13.1864 16.0495V16.4095C13.1864 16.5259 13.281 16.6204 13.3973 16.6204H14.888C15.0043 16.6204 15.0989 16.5259 15.0989 16.4095V16.0495C15.0989 15.7348 14.843 15.4786 14.528 15.4786H14.3536V12.2034H14.9098ZM14.6774 16.0491V16.1982H13.6086V16.0491C13.6086 15.9669 13.6754 15.9001 13.7577 15.9001H14.5287C14.6106 15.9004 14.6774 15.9672 14.6774 16.0491ZM13.7457 10.4748C13.7524 10.4094 13.8073 10.3602 13.873 10.3602H14.4127C14.4795 10.3602 14.5329 10.4083 14.5399 10.4748L14.6756 11.7815H13.61L13.7457 10.4748ZM3.16793 8.20789C3.05156 8.20789 2.95699 8.11332 2.95699 7.99695V7.09484H2.05488C1.93852 7.09484 1.84395 7.00027 1.84395 6.88391C1.84395 6.76754 1.93852 6.67297 2.05488 6.67297H2.95699V5.77086C2.95699 5.65449 3.05156 5.55992 3.16793 5.55992C3.2843 5.55992 3.37887 5.65449 3.37887 5.77086V6.67297H4.28098C4.39734 6.67297 4.49191 6.76754 4.49191 6.88391C4.49191 7.00027 4.39734 7.09484 4.28098 7.09484H3.37887V7.99695C3.37887 8.11332 3.2843 8.20789 3.16793 8.20789ZM17.0445 5.5318L9.77695 0.56422C9.70629 0.515704 9.61312 0.515001 9.54176 0.562462L3.84152 4.33051C3.62637 4.27356 3.40066 4.24297 3.16793 4.24297C1.71176 4.24332 0.527344 5.42774 0.527344 6.88391C0.527344 8.26871 1.59926 9.40742 2.95699 9.51535V17.2617C2.95699 17.378 3.05156 17.4726 3.16793 17.4726H15.9064C16.0228 17.4726 16.1174 17.378 16.1174 17.2617V7.25621C16.2369 7.30508 16.3624 7.32899 16.4872 7.32899C16.8015 7.32899 17.1109 7.17887 17.3014 6.90043C17.608 6.45219 17.4927 5.83836 17.0445 5.5318ZM0.949219 6.88391C0.949219 5.66047 1.94449 4.6652 3.16793 4.6652C4.39137 4.6652 5.38664 5.66047 5.38664 6.88391C5.38664 8.10734 4.39137 9.10262 3.16793 9.10262C1.94449 9.10262 0.949219 8.10699 0.949219 6.88391ZM3.37887 17.0507V9.515C4.7366 9.40707 5.80852 8.26871 5.80852 6.88356C5.80852 6.42125 5.68863 5.98672 5.4791 5.60844L9.6416 2.85676L15.6955 6.995V17.0507H3.37887ZM16.9534 6.66242C16.7783 6.91871 16.4275 6.98445 16.1712 6.80938L9.76254 2.42856C9.69188 2.38004 9.59871 2.37934 9.52734 2.4268L5.24566 5.25723C5.00133 4.94574 4.68844 4.68981 4.3302 4.51332L9.65602 0.992423L16.8064 5.8802C17.0624 6.05527 17.1285 6.40613 16.9534 6.66242Z" fill="black" stroke="black" strokeWidth="0.3" />
                </g>
                <defs>
                    <clipPath id="clip0_715_1020">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        },
        {
            id: 3,
            apiName: "Style Transfer",
            name: `${t("enhancementList.Style Transfer")}`,
            component: <StyleTransfer image={props.imageValue} onEnhancedImage={EnhancedImageHandler} />,
            popUp: true,
            allowReapply: true,
            svg: <svg width="18" height="18" className="marg-right-10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.77436 0.485404C9.67586 0.487319 9.57871 0.50857 9.48845 0.548035C9.39819 0.5875 9.31658 0.644419 9.2483 0.715425C9.18001 0.78643 9.12638 0.870148 9.09047 0.961882C9.05456 1.05362 9.03707 1.15154 9.039 1.25004V14.7471C9.03971 14.8997 9.08695 15.0485 9.17442 15.1735C9.26189 15.2986 9.38543 15.394 9.52854 15.4471C9.67165 15.5001 9.82753 15.5081 9.97536 15.4702C10.1232 15.4323 10.2559 15.3502 10.3559 15.2349L14.8574 9.98633C14.9218 9.91146 14.9709 9.82465 15.0017 9.73079C15.0325 9.63692 15.0445 9.53785 15.0369 9.43935C15.0294 9.34084 15.0025 9.24481 14.9578 9.15673C14.913 9.06865 14.8513 8.9903 14.7763 8.9261C14.7012 8.86191 14.6141 8.81308 14.5202 8.78259C14.4262 8.7521 14.3271 8.74046 14.2287 8.74833C14.1302 8.7562 14.0342 8.78349 13.9463 8.82852C13.8584 8.87356 13.7802 8.93549 13.7163 9.01079L10.5331 12.7212V1.25004C10.5351 1.14958 10.5169 1.0497 10.4795 0.956432C10.4421 0.86316 10.3864 0.778354 10.3156 0.707034C10.2449 0.635713 10.1605 0.579368 10.0675 0.541287C9.97451 0.503206 9.87483 0.484217 9.77436 0.485404ZM5.26264 0.496736C5.15776 0.500356 5.05481 0.525926 4.96044 0.571824C4.86607 0.617722 4.78238 0.68291 4.71479 0.763176L0.219181 6.0117C0.146239 6.08478 0.0891724 6.17212 0.0515535 6.26828C0.0139347 6.36444 -0.00342598 6.46735 0.000558798 6.57053C0.00454358 6.67371 0.0297878 6.77497 0.0747109 6.86794C0.119634 6.96091 0.183268 7.04361 0.261629 7.11085C0.339989 7.17809 0.431389 7.22841 0.530103 7.25869C0.628817 7.28897 0.73272 7.29854 0.835306 7.28681C0.937891 7.27507 1.03695 7.24231 1.12628 7.19052C1.21561 7.13874 1.29328 7.06904 1.35443 6.98585L4.53754 3.27688V14.7481C4.53532 14.848 4.55308 14.9473 4.58978 15.0402C4.62648 15.1331 4.68137 15.2178 4.75123 15.2893C4.82109 15.3607 4.90452 15.4174 4.99662 15.4561C5.08871 15.4949 5.18762 15.5149 5.28754 15.5149C5.38746 15.5149 5.48636 15.4949 5.57846 15.4561C5.67056 15.4174 5.75399 15.3607 5.82385 15.2893C5.89371 15.2178 5.9486 15.1331 5.9853 15.0402C6.022 14.9473 6.03976 14.848 6.03754 14.7481V1.25099C6.03831 1.14992 6.01864 1.04971 5.97972 0.956432C5.9408 0.863155 5.88343 0.778707 5.81105 0.708158C5.73867 0.637609 5.65279 0.582397 5.55855 0.545872C5.4643 0.509347 5.36365 0.493388 5.26264 0.496736Z" fill="black" />
            </svg>
        },
        {
            id: 4,
            apiName: "Remove Furniture",
            name: "Unfurnish Room",
            component: "",
            popUp: false,
            allowReapply: true,
            svg: <svg width="18" height="18" className="marg-right-10" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.89321 9L14.815 4.07817C15.0617 3.83152 15.0617 3.43163 14.815 3.18499C14.5684 2.93834 14.1685 2.93834 13.9218 3.18499L8.99999 8.10682L4.07817 3.18499C3.83151 2.93834 3.43162 2.93834 3.18499 3.18499C2.93836 3.43165 2.93834 3.83154 3.18499 4.07817L8.10681 9L3.18499 13.9218C2.93834 14.1685 2.93834 14.5684 3.18499 14.815C3.43165 15.0617 3.83154 15.0616 4.07817 14.815L8.99999 9.89318L13.9218 14.815C14.1684 15.0617 14.5683 15.0616 14.815 14.815C15.0616 14.5684 15.0616 14.1685 14.815 13.9218L9.89321 9Z" fill="black" />
            </svg>
        },
        {
            id: 5,
            apiName: "3D Floor plan",
            name: `${t("enhancementList.3D Floor plan")}`,
            component: <FloorPlan image={props.imageValue} onEnhancedImage={EnhancedImageHandler} />,
            popUp: false,
            allowReapply: true,
            svg: <svg width="18" height="18" className="marg-right-10" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_715_967)">
                    <path d="M11.7703 6.24656C11.7596 6.07366 11.6584 5.91057 11.5076 5.82489L8.25349 3.94846C8.09047 3.85442 7.88962 3.85442 7.72664 3.94846L4.49293 5.81318C4.33157 5.90459 4.22782 6.0848 4.22901 6.27V10.0053C4.22901 10.1938 4.32963 10.368 4.49293 10.4621L7.7464 12.3383C7.90618 12.4321 8.11396 12.4322 8.27385 12.3386L11.5076 10.4735C11.6709 10.3793 11.7715 10.2051 11.7715 10.0166C11.7703 9.96493 11.7737 6.29602 11.7703 6.24656ZM7.99007 5.01401L10.1885 6.28171L8.01035 7.5377L5.81199 6.27L7.99007 5.01401ZM5.2837 7.18284L7.48304 8.4511V10.9689L5.2837 9.70066V7.18284ZM10.7168 9.71201L8.53773 10.9688V8.45106L10.7168 7.19451V9.71201Z" fill="black" />
                    <path d="M17.6671 6.52757C17.4662 6.44787 17.237 6.49881 17.0887 6.65624L16.9453 6.80857V2.28498C16.9453 1.99375 16.7092 1.75764 16.418 1.75764H3.16406V0.527344C3.16406 0.236109 2.92795 0 2.63672 0H1.58203C0.709699 0 0 0.709699 0 1.58203V2.28516V14.3085V15.3632V15.3632V15.3633C0 16.2356 0.709699 16.9453 1.58203 16.9453H7.40071L7.24454 17.1112C7.1003 17.2644 7.06092 17.4886 7.14435 17.6818C7.22777 17.8749 7.41804 18 7.62848 18H17.4727C17.7639 18 18 17.7639 18 17.4727V7.01775C18 6.80157 17.8681 6.6073 17.6671 6.52757ZM1.05469 1.58203C1.05469 1.29125 1.29125 1.05469 1.58203 1.05469H2.10938V13.7812H1.58203C1.58094 13.7812 1.57985 13.7814 1.57876 13.7814C1.39743 13.7817 1.22084 13.8125 1.05469 13.8711V2.28516V1.58203ZM1.58203 15.8906C1.29125 15.8906 1.05469 15.6541 1.05469 15.3633C1.04871 15.08 1.29888 14.8301 1.58203 14.8359H2.63672C2.92795 14.8359 3.16406 14.5998 3.16406 14.3086V14.3086V14.3085V2.81232H15.8906V7.92868L8.3938 15.8906H1.58203ZM16.9453 16.9453H8.84936L16.9453 8.34708V16.9453Z" fill="black" />
                    <path d="M12.0276 15.5724C12.111 15.7655 12.3013 15.8906 12.5117 15.8906H15.3631C15.6543 15.8906 15.8904 15.6545 15.8904 15.3633V12.335C15.8904 12.1188 15.7585 11.9245 15.5575 11.8448C15.3566 11.7651 15.1274 11.8161 14.9792 11.9735L12.1278 15.0017C11.9836 15.155 11.9442 15.3792 12.0276 15.5724ZM14.8358 13.6643V14.8359H13.7326L14.8358 13.6643Z" fill="black" />
                </g>
                <defs>
                    <clipPath id="clip0_715_967">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        },
        {
            id: 6,
            apiName: "Generate QR Code",
            name: `${t("enhancementList.Generate QR Code")}`,
            component: <GenerateQRCode />,
            popUp: true,
            svg: <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="marg-right-10"
            >
                <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm6 0h2v2h-2V5zm0 4h2v2h-2V9zm4-6h6v6h-6V3zm2 2v2h2V5h-2zm-2 6h2v2h-2v-2zm4 0h2v2h-2v-2zm-6 2h2v2h-2v-2zm8 0h2v2h-2v-2zM3 13h6v6H3v-6zm2 2v2h2v-2H5zm6 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-4 4h2v2h-2v-2zm4 0h6v2h-6v-2z" />
            </svg>

        }
    ];

    const excludedItems = [ "Generate QR Code", "Room Image Generation"];

    const filteredEnhancements = pathname === "Enhance-Generate"
        ? listGeneration : listGeneration.filter(item => !excludedItems.includes(item.apiName));

    const handleCloseDialog = () => {
        setOpenPopUp(false);
    };

    const getMatchedRecommendation = (apiname: any, recommendations: any[]) => {
        return recommendations.find((rec) => rec.apiName === apiname);
    };

    const getEnhancementifdone = (doneEnhancments: any, apiname: any): string => {
        const isDone = doneEnhancments && doneEnhancments.includes(apiname);
        return isDone ? "Done" : "Apply";
    };

    const getIsApplying = (apiName: string, id: string | number) => {
        // Disable if Image Super Resolution already applied
        if (apiName === "Image Super Resolution" && (currentImage?.doneEnhancments || []).includes("Image Super Resolution")) {
            return true;
        }

        return props.isApplyingMap[id] || false;
    };

    const getIsHideItem = (apiName: string, id: string | number) => {
        // Handle floorplan images - only enable "3D Floor plan"
        if (currentImage?.room_type === "floorplan") {
            return apiName !== "3D Floor plan";
        }

        // Handle property interior detection
        if (currentImage?.out_in_door_detection === "property_interior") {
            const allowedInteriorApis = ["Room Staging", "Room Remodeling", "Style Transfer", "Remove Furniture"];
            return !allowedInteriorApis.includes(apiName);
        }

        // Handle property exterior detection
        if (currentImage?.out_in_door_detection === "property_exterior") {
            const allowedExteriorApis = ["Room Remodeling"];
            return !allowedExteriorApis.includes(apiName);
        }

        return false;
    };

    const handleClick = (apiName: string) => {
        setIsStateValue(apiName);
        setOpenPopUp(false);

        const enhancementItem = getMatchedRecommendation(apiName, listGeneration);

        if (apiName && accessValue?.[apiName] === false) {
            setShowUpgrade(true);
            return;
        }
        if (enhancementItem?.popUp === true) {
            setOpenPopUp(true);
        } else {
            props.onEnhancedImage(props.imageValue, apiName, null);
        }
    };

    

    return (

        <>
            <div className="generate-container">
                <h3 className="title-20 color-746AFF mb-4">
                    {t("enhancementList.generate")}
                </h3>
                <ul className="p-0 m-0 list-style-none mb-0">
                    {filteredEnhancements.map((obj: any, index: any) => (
                        <GenerationItem
                            key={index}
                            apiName={obj.apiName}
                            svg={obj.svg}
                            label={obj}
                            doneEnhancements={getEnhancementifdone(currentImage?.doneEnhancments || [], obj.apiName)}
                            loadingItem={props.processingIds.includes(`${props.listing.images[props.currentImageIndex]?.id}:${obj.apiName}`)}
                            isApplying={getIsApplying(obj.apiName, currentImage.id)}
                            onClick={(value: string) => handleClick(value)}
                            allowReapply={obj.allowReapply}
                            disableAll={disableAll}
                            hideItem={getIsHideItem(obj.apiName, currentImage.id)}
                        />
                    ))}
                </ul>
            </div>

            <BootstrapDialog
                onClose={() => setShowUpgrade(false)}
                aria-labelledby="customized-dialog-title"
                open={showUpgrade}
                fullWidth={true}
                maxWidth="xl"
            >
                <IconButton
                    aria-label="close"
                    onClick={() => setShowUpgrade(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <div className="padd-20" >
                        <UpgradeDetails />
                    </div>
                </DialogContent>
            </BootstrapDialog>

            <BootstrapDialog
                open={openPopUp}
                onClose={handleCloseDialog}
                aria-labelledby="customized-dialog-title"
                fullWidth={true}
                maxWidth={(stateValue == "Generate QR Code" ? "lg" : stateValue == "Room Staging" ? "md" : "sm")}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" >
                    <div className="title-24 title-20-mb">
                        {t(`enhancementList.${stateValue}`)}
                    </div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    {getMatchedRecommendation(stateValue, listGeneration)?.component}
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}

export default AdvancedGeneration;